import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

var Country = function Country(context) {
  var _this = this;

  _classCallCheck(this, Country);

  _defineProperty(this, "getByCrmGuid", function (id) {
    return _this.context.http.get("/msvc/v1/countries/crmguid=".concat(id));
  });

  this.context = context;
};

export default Country;